import React, { useState } from "react";

const Spinner = () => (
  <svg
    className="animate-spin h-5 w-5 text-white"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

const SearchForm = ({ onSearch, loading }) => {
  const [searchType, setSearchType] = useState("aadhaar");
  const [searchValue, setSearchValue] = useState("");

  const handleSearchClick = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchType, searchValue);
    }
  };

  const getPlaceholder = () => {
    switch (searchType) {
      case "aadhaar":
        return "Aadhaar Number";
      case "rc":
        return "RC Number";
      case "application":
        return "Application Number";
      default:
        return "Search Value";
    }
  };

  return (
    <form onSubmit={handleSearchClick} className="w-full max-w-3xl mx-auto">
      <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
        <thead>
          <tr className="tableheader">
            <th className="text-left max-sm:text-xs px-4 py-2 border-b">
              Search By
            </th>
            <th className="text-left max-sm:text-xs px-4 py-2 border-b">
              Search Value
            </th>
            {/* <th className="text-left max-sm:text-xs px-4 py-2 border-b">
              Action
            </th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 border-b">
              <select
                value={searchType}
                onChange={(e) => {
                  setSearchType(e.target.value);
                  setSearchValue("");
                }}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-300 max-sm:text-xs max-sm:py-1 max-sm:px-2"
                disabled={loading}
              >
                <option value="aadhaar">Aadhaar Number</option>
                <option value="rc">RC Number</option>
                <option value="application">Application Number</option>
              </select>
            </td>

            <td className="px-4 py-3 border-b">
              <input
                type="text"
                placeholder={`Enter ${getPlaceholder()}`}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                disabled={loading}
                maxLength={searchType === "aadhaar" ? 12 : 20}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-300 disabled:bg-gray-100 max-sm:py-1 max-sm:px-2"
              />
            </td>

            {/* <td className="px-4 py-3 border-b text-center">
              
            </td> */}
          </tr>
            <tr>
              <td colSpan={10} align="center">
                <button
                type="submit"
                disabled={loading || !searchValue.trim()}
                className="button button-2"
              >
                {loading ? <Spinner /> : "Search"}
              </button>
              </td>
            </tr>
        </tbody>
      </table>
    </form>
  );
};

export default SearchForm;
